"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Controller_1 = require("../Controller");
var wixCodeApiManager_js_1 = require("wix-comments-ooi/dist/src/wixCodeApiManager.js");
var PubSubEventTypes_1 = require("../pubSub/PubSubEventTypes");
var CommentsController = /** @class */ (function (_super) {
    tslib_1.__extends(CommentsController, _super);
    function CommentsController(controllerConfig, groupId) {
        var _this = _super.call(this, controllerConfig, groupId) || this;
        _this.setWixCodeApiParams = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, wixCodeApi, appParams, compId, wixCodeApiParams;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.controllerConfig, wixCodeApi = _a.wixCodeApi, appParams = _a.appParams, compId = _a.compId;
                        return [4 /*yield*/, wixCodeApiManager_js_1.default(wixCodeApi, appParams, compId)];
                    case 1:
                        wixCodeApiParams = _b.sent();
                        this.controllerConfig.setProps({ wixCodeApiParams: wixCodeApiParams });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onUserLogin(function (_a) {
            var instance = _a.instance;
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.setWixCodeApiParams()];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        });
        _this.setSubscriptions();
        return _this;
    }
    CommentsController.prototype.pageReady = function () {
        this.controllerConfig.setProps({
            setWixCodeApiParams: this.setWixCodeApiParams,
        });
        return;
    };
    CommentsController.prototype.setSubscriptions = function () {
        try {
            this.controllerConfig.platformAPIs.pubSub.subscribe(PubSubEventTypes_1.PubSubEventTypes.UPDATE_CONTEXT_TOKENS_EVENT, this.setWixCodeApiParams, false);
        }
        catch (e) {
            console.log('FAILED in CommentsController.setSubscriptions');
        }
    };
    return CommentsController;
}(Controller_1.Controller));
exports.CommentsController = CommentsController;
//# sourceMappingURL=CommentsController.js.map